import React from "react";
// src/constants.ts
import { SvgIconComponent } from '@mui/icons-material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SchoolIcon from '@mui/icons-material/School';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import InsightsIcon from '@mui/icons-material/Insights';
import BrushIcon from '@mui/icons-material/Brush';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import { navigationData, NavigationItem } from './navigation.data';

// This is a frontend-only file. It imports the raw navigation data
// and "hydrates" it with the required React components (icons).

export interface MenuItemInfo extends NavigationItem {
    icon: React.ReactElement<SvgIconComponent>;
    subItems?: Partial<MenuItemInfo>[];
}

// Create a map of navId to the corresponding icon component.
const iconMap: { [key: string]: React.ReactElement<SvgIconComponent> } = {
    dashboard: <DashboardIcon />,
    skills: <SchoolIcon />,
    advisor: <InsightsIcon />,
    studio: <BrushIcon />,
    library: <LibraryBooksIcon />,
    assist: <RocketLaunchIcon />,
    admin: <AdminPanelSettingsIcon />,
    'vendor-hub': <ControlCameraIcon />,
};

// Hydrate the raw data with the icons to create the final menuItems array for the UI.
export const menuItems: MenuItemInfo[] = navigationData.map(item => ({
    ...item,
    icon: iconMap[item.navId] || <DashboardIcon />, // Provide a default icon
}));
